export default __webpack_public_path__ + "static/media/chbg.b20f8654.jpg";